import React from 'react';

const TimeInput = (props) => {
    return (
        <div className="col-lg-6 input-group-sm">
            <div className="col-12 mb-3">
                <button className={props.className} type="button" onClick={props.onClick}>{props.buttonName}</button>
            </div>
            <input
                className="form-control"
                type="text"
                name="startTime"
                placeholder={props.placeholder}
                value={props.value} onChange={props.onChange}
            />
        </div>
    );
}

export default TimeInput